import { render, staticRenderFns } from "./SmsLogin.vue?vue&type=template&id=21a4ada8&scoped=true&"
import script from "./SmsLogin.vue?vue&type=script&lang=js&"
export * from "./SmsLogin.vue?vue&type=script&lang=js&"
import style0 from "./SmsLogin.vue?vue&type=style&index=0&id=21a4ada8&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a4ada8",
  null
  
)

export default component.exports